import Vue from 'vue'
import VueRouter from 'vue-router'
import CompanyPage from "../pages/CompanyPage.vue";
import AdminsPage from "../pages/AdminsPage.vue";
import AccountSettingsPage from "../pages/AccountSettingsPage.vue";
import SubCompanyPage from "../pages/SubCompanyPage.vue";
// import DepartamentsPage from "../pages/DepartamentsPage.vue";
import BankAccountsPage from "../pages/BankAccountsPage.vue";
import DriverPage from "../pages/DriverPage.vue";
import DriverDetailsPage from "../pages/DriverDetailsPage.vue";
import FleetPage from "../pages/FleetPage.vue";
import SubFleetPage from "../pages/SubFleetPage.vue";
import DriverFleetPage from "../pages/DriverFleetPage.vue";
import FuelCardsPage from "../pages/FuelCardsPage.vue";
import DashboardPage from "../pages/DashboardPage.vue";
import NotificationsPage from "../pages/NotificationsPage.vue";

import DocumentTemplatesPage from "../pages/DocumentTemplatesPage.vue";
import PendingDocuments from "../pages/PendingDocuments.vue";
import PendingDriversChangesPage from "../pages/PendingDriversChangesPage.vue";
import DriverOnboardingPage from "../pages/DriverOnboardingPage.vue";
import InvoicesPage from "../pages/InvoicesPage.vue";
import IncomesPage from "../pages/IncomesPage.vue";
import LoginPage from "../pages/LoginPage.vue";
import BonusPage from "../pages/BonusPage.vue";
import UploaderTemplatesPage from "../pages/UploaderTemplatesPage.vue";
import UploaderPage from "../pages/UploaderPage.vue";
import SettlementsPage from "../pages/SettlementsPage.vue";
import ImportHistoryPage from "../pages/ImportHistoryPage.vue";
import KomornikLettersPage from "../pages/KomornikLettersPage.vue";
import CostInvoicesPage from "../pages/CostInvoicesPage.vue";
import CashReportPage from "../pages/CashReportPage.vue";
import CarRentPage from "../pages/CarRentPage.vue";
import FleetDetailsPage from "../pages/FleetDetailsPage.vue";
import InspectionsPage from "../pages/InspectionsPage.vue";
import CarCrashPage from "../pages/CarCrashPage.vue";
import CarCrashDetails from "../pages/CarCrashDetails.vue";
import PayoutsPage from "../pages/PayoutsPage.vue";
import SkippedImportPage from "../pages/SkippedImportPage.vue";
import ArchiveDriversPage from '../pages/ArchiveDriversPage.vue';
import ContractsPage from '@/pages/ContractsPage.vue';
import TasksPage from '@/pages/TasksPage.vue';
import PayoutConfigPage from '@/pages/PayoutConfigPage.vue';
import RachunkiPage from '@/pages/RachunkiPage.vue';
import WikiPage from '@/pages/WikiPage.vue';
import WikiArticlePage from '@/pages/WikiArticlePage.vue';
import AuditLogsPage from '@/pages/AuditLogsPage.vue';
import StaffActivityPage from '@/pages/StaffActivityPage.vue';
import EmailConfigPage from '@/pages/EmailConfigPage.vue';
import AppVersionPage from '@/pages/AppVersionPage.vue';
import RentToOwnPage from '@/pages/RentToOwnPage.vue';
import DebtorsPage from '@/pages/DebtorsPage.vue';
import NotificationLogsPage from '@/pages/NotificationLogsPage.vue';
import ChatPage from '@/pages/ChatPage.vue';
import DocumentsRepositoryPage from '@/pages/DocumentsRepositoryPage.vue';
import SmsPage from '@/pages/SmsPage.vue';
import AccountingPage from '@/pages/AccountingPage.vue';
import EmailPage from '@/pages/EmailPage.vue';
import WykazPojazdyPage from '@/pages/WykazPojazdyPage.vue';
import WykazKierowcyPage from '@/pages/WykazKierowcyPage.vue';
import PointsSettingsPage from '@/pages/PointsSettingsPage.vue';
import PointsReferralsPage from '@/pages/PointsReferralsPage.vue';
import PointsReviewsPage from '@/pages/PointsReviewsPage.vue';
import PointsRewardOrdersPage from '@/pages/PointsRewardOrdersPage.vue';
import PointsDriversPage from '@/pages/PointsDriversPage.vue';
import AnnouncementsPage from '@/pages/AnnouncementsPage.vue';
import WebsiteLeadsPage from '@/pages/WebsiteLeadsPage.vue';
import OfficialDocumentsPage from '@/pages/OfficialDocumentsPage.vue';
import CompanyLicensesPage from '@/pages/CompanyLicensesPage.vue';
import LegalizationPage from "../pages/LegalizationPage.vue";
import MarketingPostsPage from "../pages/MarketingPostsPage.vue";
import HrPage from '@/pages/HrPage.vue';
import WorkTimePage from '@/pages/WorkTimePage.vue';
import SignaturePadPage from '@/pages/SignaturePadPage.vue';
import SystemSettingsPage from '@/pages/SystemSettingsPage.vue';
import AssistantPage from '@/pages/AssistantPage.vue';
import DailyPayoutsPage from '@/pages/DailyPayoutsPage.vue';
import SelfServicePayoutsPage from '@/pages/SelfServicePayoutsPage.vue';
import BoltSyncDriversPage from '@/pages/BoltSyncDriversPage.vue';
import IntegrationsPage from '@/pages/IntegrationsPage.vue';
import PolicySalesPage from '@/pages/PolicySalesPage.vue';
import ClaimsPage from '@/pages/ClaimsPage.vue';


Vue.use(VueRouter)

const routes = [
  { path: '/claim-transfer', component: () => import('../pages/ClaimTransferPage.vue') },
  { path: '/claim-upload/:token', component: () => import('../pages/ClaimTransferPage.vue') },
  {
    path: "/login",
    name: "LoginPage",
    component: LoginPage,
  },
  {
    path: "/fleet",
    name: "FleetPage",
    component: FleetPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/sub-fleet",
    name: "SubFleetPage",
    component: SubFleetPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/driver-fleet",
    name: "DriverFleetPage",
    component: DriverFleetPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/drivers-archive",
    name: "DriversArchivePage",
    component: ArchiveDriversPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/crashes",
    name: "CarCrashesPage",
    component: CarCrashPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/claims",
    name: "ClaimsPage",
    component: ClaimsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/crash-history",
    name: "CarCrashDetails",
    component: CarCrashDetails,
    meta: { requiresAuth: true },
  },
  {
    path: "/tasks",
    name: "TaskPageVue",
    component: TasksPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/fleet-details",
    name: "FleetDetails",
    component: FleetDetailsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/settlements",
    name: "SettlementsPage",
    component: SettlementsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/payouts",
    name: "PayoutsPage",
    component: PayoutsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/daily-payouts",
    name: "DailyPayoutsPage",
    component: DailyPayoutsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/self-service-payouts",
    name: "SelfServicePayoutsPage",
    component: SelfServicePayoutsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/bolt-sync-drivers",
    name: "BoltSyncDriversPage",
    component: BoltSyncDriversPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/integrations",
    name: "IntegrationsPage",
    component: IntegrationsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/car-rent",
    name: "CarRentPage",
    component: CarRentPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/cost-invoices",
    name: "CostInvoicesPage",
    component: CostInvoicesPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/cash-report",
    name: "CashReportPage",
    component: CashReportPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/import-history",
    name: "ImportHistoryPage",
    component: ImportHistoryPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/skipped-import",
    name: "SkippedImportPage",
    component: SkippedImportPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/komornik-letters",
    name: "KomornikLettersPage",
    component: KomornikLettersPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/uploader-templates",
    name: "UploaderTemplatesPage",
    component: UploaderTemplatesPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/uploader",
    name: "UploaderPage",
    component: UploaderPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/bonuses",
    name: "BonusPage",
    component: BonusPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/invoices",
    name: "InvoicesPage",
    component: InvoicesPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/incomes",
    name: "IncomesPage",
    component: IncomesPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/fuel-cards",
    name: "FuelCardsPage",
    component: FuelCardsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/inspections",
    name: "InspectionsPage",
    component: InspectionsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/company",
    name: "CompanyPage",
    component: CompanyPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/drivers",
    name: "DriverPage",
    component: DriverPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/driver-details",
    name: "DriverDetailsPage",
    component: DriverDetailsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/subcompanies",
    name: "SubCompanyPage",
    component: SubCompanyPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/admins",
    name: "AdminsPage",
    component: AdminsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/account-settings",
    name: "AccountSettingsPage",
    component: AccountSettingsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/notifications",
    name: "NotificationsPage",
    component: NotificationsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/notification-logs",
    name: "NotificationLogs",
    component: NotificationLogsPage,
    meta: { requiresAuth: true },
  },
  // {
  //   path: "/departaments",
  //   name: "DepartamentsPage",
  //   component: DepartamentsPage,
  //   meta: { requiresAuth: true },
  // },
  {
    path: "/document-templates",
    name: "DocumentTemplatesPage",
    component: DocumentTemplatesPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/pending-documents",
    name: "PendingDocuments",
    component: PendingDocuments,
    meta: { requiresAuth: true },
  },
  {
    path: "/pending-drivers-changes",
    name: "PendingDriversChanges",
    component: PendingDriversChangesPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/driver-onboarding",
    name: "DriverOnboardingPage",
    component: DriverOnboardingPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/dashboard",
    name: "DashboardPage",
    component: DashboardPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/bank-accounts",
    name: "BankAccountsPage",
    component: BankAccountsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/contracts",
    name: "ContractsPage",
    component: ContractsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/payout-config",
    name: "PayoutConfigPage",
    component: PayoutConfigPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/staff-activity",
    name: "StaffActivityPage",
    component: StaffActivityPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/receipts",
    name: "RachunkiPage",
    component: RachunkiPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/wiki",
    name: "WikiPage",
    component: WikiPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/wiki/article/:id",
    name: "WikiArticlePage",
    component: WikiArticlePage,
    meta: { requiresAuth: true },
  },
  {
    path: "/audit-logs",
    name: "AuditLogsPage",
    component: AuditLogsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/assistant",
    name: "AssistantPage",
    component: AssistantPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/system-settings",
    name: "SystemSettingsPage",
    component: SystemSettingsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/mail-config",
    name: "EmailConfigPage",
    component: EmailConfigPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/rent-to-own",
    name: "RentToOwnPage",
    component: RentToOwnPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/app-version",
    name: "AppVersionPage",
    component: AppVersionPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/debtors",
    name: "DebtorsPage",
    component: DebtorsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/chat",
    name: "ChatPage",
    component: ChatPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/documents-repository",
    name: "DocumentsRepositoryPage",
    component: DocumentsRepositoryPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/accounting",
    name: "AccountingPage",
    component: AccountingPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/sms",
    name: "SmsPage",
    component: SmsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/email",
    name: "EmailPage",
    component: EmailPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/policy-sales",
    name: "PolicySalesPage",
    component: PolicySalesPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/wykaz-pojazdy",
    name: "WykazPojazdyPage",
    component: WykazPojazdyPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/wykaz-kierowcy",
    name: "WykazKierowcyPage",
    component: WykazKierowcyPage,
    meta: { requiresAuth: true },
  },
{
    path: "/points-settings",
    name: "PointsSettingsPage",
    component: PointsSettingsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/points-referrals",
    name: "PointsReferralsPage",
    component: PointsReferralsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/points-reviews",
    name: "PointsReviewsPage",
    component: PointsReviewsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/points-reward-orders",
    name: "PointsRewardOrdersPage",
    component: PointsRewardOrdersPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/points-drivers",
    name: "PointsDriversPage",
    component: PointsDriversPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/",
    name: "AdminsPage",
    component: AdminsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/announcements",
    name: "AnnouncementsPage",
    component: AnnouncementsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/website-leads",
    name: "WebsiteLeadsPage",
    component: WebsiteLeadsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/official-documents",
    name: "OfficialDocumentsPage",
    component: OfficialDocumentsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/company-licenses",
    name: "CompanyLicensesPage",
    component: CompanyLicensesPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/driver-map",
    name: "DriverMapPage",
    component: () => import('../pages/DriverMapPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: "/legalization",
    name: "LegalizationPage",
    component: LegalizationPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/marketing-posts",
    name: "MarketingPostsPage",
    component: MarketingPostsPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/hr",
    name: "HrPage",
    component: HrPage,
    meta: { requiresAuth: true },
  },
  {
    path: "/work-time",
    name: "WorkTimePage",
    component: WorkTimePage,
    meta: { requiresAuth: true },
  },
  {
    // Ekran tabletu do podpisu — BEZ logowania. Tablet uwierzytelnia się
    // własnym tokenem z parowania i nie ma dostępu do reszty panelu.
    path: "/podpis",
    name: "SignaturePadPage",
    component: SignaturePadPage,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // Check if the route requires authentication
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    // Check if user is logged in
    if (!isLoggedIn()) {
      // If user is not logged in, redirect to login page
      next("/login");
    } else {
      // If user is logged in, proceed to the route
      next();
    }
  } else {
    // Zalogowany użytkownik na /login → na dashboard (nie pokazujemy formularza
    // logowania ani chrome'u pod nim).
    if (to.path === "/login" && isLoggedIn()) {
      next("/");
    } else {
      next();
    }
  }
});

function isLoggedIn() {
  const token = localStorage.getItem("token");
  return token !== null && token !== "null" && token !== "undefined" && token !== "";
}
export default router;
